import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { User } from 'src/app/models/user.model';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { UsersStore } from 'src/app/features/users/users-store';

@Component({
    selector: 'que-contact-display',
    imports: [CommonModule, TranslateDirective, TranslatePipe],
    templateUrl: './contact-display.component.html',
    styleUrls: ['./contact-display.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContactDisplayComponent {
  @Input()
  contact?: User;
  @Input()
  isGroup: boolean = false;
  @Input()
  canDelete: boolean = true;
  #usersStore = inject(UsersStore);
  delete() {
    if (this.contact) {
      this.#usersStore.RemoveRecipient(this.contact);
    }

  }
}
